/**
 * Toggles all detail elements on a page open or closed and returns which were open before toggling
 *
 * @param {boolean}              toggleValue     - Whether to toggle on or off the element
 * @param {HTMLDetailsElement[]} omittedElements - Which elements to skip
 * @return {HTMLDetailsElement[]} - List of details which were already open
 */
function toggleAllDetails( toggleValue, omittedElements = [] ) {
	const programDetails = document.querySelectorAll( 'details' );

	if ( programDetails.length === 0 ) {
		return [];
	}

	const openedPrograms = [];

	programDetails.forEach( detailElement => {
		if ( omittedElements.includes( detailElement ) ) {
			return;
		}

		if ( detailElement.open === true ) {
			openedPrograms.push( detailElement );
		}

		detailElement.open = toggleValue;
	} );

	return openedPrograms;
}

/**
 *	Toggles the filters on the programs page open or closed
 *
 * @param {boolean} toggleOpen - whether the filters will show or not
 */
function toggleFilters( toggleOpen ) {
	const filters = document.querySelector( '.js-program-archive-sidebar' );
	if ( ! filters ) {
		return;
	}
	if ( toggleOpen ) {
		filters.style.display = 'block';
	} else {
		filters.style.display = '';
	}
}

/**
 * Toggles showing the href of a element in the
 *
 * @param {string|HTMLElement} selector - The selector or html element you want to show the href of
 * @param {boolean}            showUrl  - Wether the href should be shown or not
 * @param {string}             linkText - The text that should be shown in the innerHTML
 * @return {string} The inner html of the element
 */
function toggleShowLinkHref( selector, showUrl, linkText = '' ) {
	let urlElement = selector;

	if ( typeof selector === 'string' ) {
		urlElement = document.querySelector( selector );
	}

	if ( ! urlElement ) {
		return '';
	}

	if ( ! showUrl ) {
		urlElement.innerHTML = linkText;
		return linkText;
	}

	const schoolLinkText = urlElement.innerHTML;
	urlElement.innerHTML = urlElement.href;
	return schoolLinkText;
}

/**
 * Toggles whether the presentation text on a school page is open or not
 *
 * @param {boolean} toggleOpen - whether the presentation text should be open
 */
function togglePresentationText( toggleOpen ) {
	const presentationText = document.querySelector( '.js-school-presentation-text' );

	if ( ! presentationText ) {
		return;
	}

	if ( toggleOpen ) {
		presentationText.classList.add( 'school__presentation--show-text' );
	} else {
		presentationText.classList.remove( 'school__presentation--show-text' );
	}
}

let openedPrograms = [];
const linkTexts = [];
const showLinkHrefSelectors = [
	'.js-sidebar-contact-info-website',
	'.js-social-instagram',
	'.js-social-facebook',
	'.js-social-snapchat',
	'.js-social-youtube',
	'.js-info-part-link',
	'.js-program-read-more',
];

window.addEventListener( 'beforeprint', () => {
	openedPrograms = toggleAllDetails( true );
	toggleFilters( true );
	togglePresentationText( true );

	for ( const showLinkHrefSelector of showLinkHrefSelectors ) {
		const linkText = toggleShowLinkHref( showLinkHrefSelector, true );
		linkTexts.push( { selector: showLinkHrefSelector, text: linkText } );
	}

	const linkElements = document.querySelectorAll( 'a' );
	for ( const linkElement of linkElements ) {
		if ( linkElement.innerHTML.toLocaleLowerCase() === 'läs mer om olika yrken och vad de kräver för utbildning på arbetsförmedlingens hemsida' ) {
			const linkText = toggleShowLinkHref( linkElement, true );
			linkTexts.push( { selector: linkElement, text: linkText } );
		}
	}
} );

window.addEventListener( 'afterprint', () => {
	toggleAllDetails( false, openedPrograms );
	toggleFilters( false );
	togglePresentationText( false );

	for ( const linkText of linkTexts ) {
		toggleShowLinkHref( linkText.selector, false, linkText.text );
	}
} );
